import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 15 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-brand text-white" data-id="element-31" data-mp="28fnqjp4j5imp">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-x-2 whitespace-nowrap px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.1em] sm:gap-x-2.5 sm:py-2 sm:text-xs sm:tracking-[0.14em]" data-id="element-32" data-mp="aokrmcqcu15i">
        <HourglassIcon className="h-3 w-3 shrink-0 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-33" data-mp="13dr536bxf1ck" />
        <span data-id="element-34" data-mp="18dwra6zffvn9">
          Scade tra<span className="hidden sm:inline" data-id="element-35" data-mp="18eesli0y5021">:</span>
        </span>
        <span className="flex items-center gap-1 tabular-nums" aria-live="off" data-id="element-36" data-mp="uedugac2g6q9">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-1" data-id="element-37" data-mp="yf7j55xc1pk7" data-mpi={index}>
              <span className="text-[11px] font-extrabold sm:text-base" data-id="element-38" data-mp="1m5jny7xa766k">
                {pad(unit.value)}
              </span>
              <span className="hidden text-[9px] tracking-normal opacity-90 sm:inline" data-id="element-39" data-mp="1r2tk06f6eg3d">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="opacity-70 sm:px-0.5" data-id="element-40" data-mp="1hc8owsypntp7">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}